<template>
    <section>
        <router-view v-if="isPublicRoute"></router-view>
        <div v-else-if="isLoading">
            <b-loading active></b-loading>
        </div>
        <div v-else>
            <div v-if="!isUpdated" class="has-background-danger has-text-white is-justified-between" style="padding: 10px">
                <span>
                    Sistema desatualizado. Por favor, atualize antes de continuar.
                </span>
                <b-button size="is-small is-pulled-right" @click="refresh">Atualizar</b-button>
            </div>
            <div v-if="!isAuthenticated">
                <login></login>
            </div>
            <div v-else-if="isRhRoute" class="rh-standalone">
                <b-message v-for="(erro, index) in erros" :key="index" title="Erro" type="is-danger" aria-close-label="Fechar mensagem">{{ erro }}</b-message>
                <router-view></router-view>
            </div>
            <div v-else>
                <section  >
                    <navbar-principal></navbar-principal>
                    <div id="body">
                        <div class="columns">
                            <sidebar></sidebar>
                            <div :class="(sidebarIsOpened) ? 'column is-10' : 'column is-12'">
                                <b-message v-for="(erro, index) in erros" v-bind:key="index" title="Erro" type="is-danger" aria-close-label="Fechar mensagem">
                                    {{ erro }}
                                </b-message>
                                <transition name="component-fade"
                                            mode="out-in">
                                    <router-view></router-view>
                                </transition>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </section>
</template>

<style>
@import '/Home/CustomizacaoCss';

</style>

<script>
    import http from '@/http'
    import login from '@/components/login.vue'
    import navbarPrincipal from '@/components/navbarPrincipal.vue'
    import sidebar from '@/components/sidebar.vue'

    import { mapState, mapActions } from 'vuex'

    export default {
        name: 'App',
        components: {
            login,
            navbarPrincipal,
            sidebar            
        },
        computed: {
            ...mapState([
                'config',
                'erros',
                'isLoading',
                'isAuthenticated',
                'isUpdated',
                'usuario'
            ]),
            ...mapState('componentes', [
                'sidebarIsOpened'
            ]),
            isPublicRoute() {
                return this.$route.matched.some(record => record.meta && record.meta.publico)
            },
            isRhRoute() {
                return this.$route.path === '/rh' || this.$route.path.startsWith('/rh/')
            },
            isPainel() {
                return (this.$route.name && this.$route.name.includes('painel') ) || ( this.usuario.nome && this.usuario.nome.includes('painel'))                    
            },
            isPortal() {
                return this.$route.path.startsWith('/portal/')
            },
           
            isPortalConvenio(){
                return this.usuario.tipos[0] == 'Convenio'
            },
            isTransportadora() {
                return this.usuario.nivel && this.usuario.nivel.toLowerCase().includes('transportadora')
            },
            isAcessoConfirmacaoTransportadora() {
                const tipo = (this.usuario.tipo || '').toString().toLowerCase()
                const rotaConfirmacao = this.$route.name && this.$route.name.toString().includes('confirmacao_transportadora')
                return tipo.includes('transportadora') || rotaConfirmacao
            }
        },
        created() {
            setTimeout(() => {this.checkUser()},500);
            window.addEventListener('resize', this.handleResize)
            document.addEventListener('serviceWorkerUpdated', this.needUpdate)
            this.handleResize()
            
        },
        beforeDestroy() {
            this.removeGlobalListeners()
        },
        beforeUnmount() {
            this.removeGlobalListeners()
        },
        methods: {
            checkUser(){                           
                if( this.usuario.nome){
                    http.post('/api/auth/checkUser', {  UserName: this.usuario.nome})
                        .then(res => res.data)
                        .then(data => {                                
                            if(!data)                            
                                this.$router.go(0);                                   
                        })                      
                }
                                        
            },            
            handleResize() {
                this.$store.commit('componentes/HANDLE_RESIZE')
            },
            needUpdate() {
                this.$store.commit('SET_ISUPDATED', false)
            },
            removeGlobalListeners() {
                window.removeEventListener('resize', this.handleResize)
            },
            toggleSidebar() {
                this.$store.commit('componentes/SET_SIDEBAR', this.$store.state.componentes.sidebarIsOpened)
            },
            ...mapActions([
                'logout'
            ]),
            refresh() {
                setTimeout(() => {
                    window.location.reload()
                })
            }
        }
    }
</script>
